import { IEntityMetaData, IPropretyAttribute } from "@app/common-codes/_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "@app/common-codes/_models/GenericEntityBase";
import { PropretyAttributes, NestedProperty, NavigationProperty } from "@app/common-codes/decorators/EntityDecorators";
import { TruckerActivity } from "@app/common-codes/models/matwins-tenant/TruckerActivity.model";
import { Trucker } from "@app/common-codes/models/matwins-tenant/Trucker.model";
import { ValidationCodeEntity } from "./verificationCode.model";
import { Employee } from "@app/common-codes/models/matwins-tenant/Employee.model";

export interface ResponsibleMessage {
  email?: string;
  message?: string;
  cellPhone?: string;
}
export class QrCodeCheckModel extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  isAuthenticated: boolean = false;
  isUnAuthorized: boolean = false;
  tenantPrefix!: string;
  posId!: string | undefined;
  clientId!: string | undefined;


  selectedActivity!: TruckerActivity;

  currentTrucker!: Trucker;

  phoneNumber!: string | undefined;
  email!: string | undefined;
  authenticationDateTime!: any;

  @NavigationProperty({ TargetType: TruckerActivity })
  activities?: TruckerActivity[];


  @NavigationProperty({ TargetType: Trucker })
  profiles?: Trucker[];

  validationCode: ValidationCodeEntity = new ValidationCodeEntity();
  truckerActivity?: TruckerActivity;
  messages: { [key: string]: string } = {};
  responsiblesMessages: ResponsibleMessage[] = [];

  responsibles!: Employee[];


  GetType(): IEntityMetaData {
    return QrCodeCheckModel.getMetaData();
  }

  static override getMetaData(): IEntityMetaData {

    let activityMetadtat = TruckerActivity.getMetaData();

    let result: IEntityMetaData = {
      EntityDisplayName: activityMetadtat.EntityDisplayName,
      EntityDisplayPlural: activityMetadtat.EntityDisplayPlural,
      Namespace: activityMetadtat.Namespace,
      EntityName: 'QrCodeCheckModel',
      EntityPluralName: '',
      EndPoint: '/qrcodechecks',

      UseTokenCheck: false,  // important

      PropertyNames: [],
      PropretyDescriptors: activityMetadtat.PropretyDescriptors
    };

    return result;
  }
}
